import script from "./FormCadastroTarefa.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCadastroTarefa.vue?vue&type=script&setup=true&lang=js"

import "./FormCadastroTarefa.vue?vue&type=style&index=0&id=8d30f214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d30f214"]])

export default __exports__